<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="msg" [token]="token">
    <div class="card-msg d-flex flex-column bg-white text-dark text-center">
        <div class="p-2">
            <app-sinalizador-nivel nivel="{{nivelSinalizador}}"></app-sinalizador-nivel>
        </div>
        {{texto}}
    </div>
</app-card-consulta>
